module.exports = __webpack_public_path__ + "media/Audio19_k.c87610bd.wav";